// extracted by mini-css-extract-plugin
export default {"dot":"_2f1eee24","activeDot":"_42b039a8"};